// 3rd party
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

// models
import { Instrument } from 'app/instruments/shared/instrument.model';
import { InstrumentBand } from 'app/instruments/shared/instrument-band.model';
import { Helper } from 'app/shared/helpers/helper';

@Injectable()
export class InstrumentService {

  constructor(
    private http: Http,
    private translate: TranslateService
  ) { }

  fillBands(instruments: Instrument[], data) {
    let bands = data as InstrumentBand[];

    this.translate.get('Translate.BandsAmplitude').subscribe((val) => {
      bands.forEach(b => {
        b.BandDescription = Helper.getRangeValueFormated(b.Name, b.MinValue, b.MaxValue, b.Precision, b.MeasurementUnit ? b.MeasurementUnit.Abbreviation : null, val);
      });
      instruments.forEach(i => {
        i.ShortBandsDescription = '';
        i.FullBandsDescription = '';
        i.InstrumentBands = bands.filter(b => b.Instrument.Identifier === i.Identifier);

        if (i.InstrumentBands) {
          if (i.InstrumentBands.length > 1) {
            i.ShortBandsDescription = i.InstrumentBands.length + ' ';
            this.translate.get('Translate.Bands').subscribe((val) => i.ShortBandsDescription += val.toLowerCase());
          } else if (i.InstrumentBands.length === 1) {
            i.ShortBandsDescription = i.InstrumentBands[0].BandDescription;
          }

          i.InstrumentBands.forEach(b => i.FullBandsDescription += b.BandDescription + '; ');
        }
      });
    });
  }

  get(identifier?: string, search?: string, orderBy?: string, sortOrder?: string, pageSize?: number, currentPage?: number, filters?: string, fields?: string): Observable<Response> {
    currentPage = currentPage || 1;

    return this.http
      .get('instruments/' + (identifier ? identifier : '') + '?fields=[' + (fields ? fields : '') + ']' + (search ? '&search=' + search : '') + (orderBy ? '&orderBy=["' + orderBy + (sortOrder ? ' ' + sortOrder : '') + '"]' : '') + (pageSize ? '&pageSize=' + pageSize + '&currentPage=' + currentPage : '') + (filters ? '&filters=[' + filters + ']' : ''))
      .map((res: Response) => res)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  getbands(instruments?: Instrument[]): Observable<InstrumentBand[]> {
    return this.http
      .get('instruments/bands/?instrumentsIdentifiers=' + instruments.map(i => i.Identifier).join(',') + '')
      .map((res: Response) => this.fillBands(instruments, res.json()))
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  getStatusDescription(status: number, isSample: boolean = false): string {
    switch (status) {
      case 2: return 'InstrumentStatus.OnExternalLaboratory';
      case 3: return 'InstrumentStatus.WaittingAnalysis';
      case 4: return 'InstrumentStatus.WaittingBudget';
      case 5: return 'InstrumentStatus.WaittingExecution';
      case 6: return isSample ? 'Assays.SampleStatus.ReadyToExpedition' : 'InstrumentStatus.ReadyToExpedition';
      case 7: return isSample ? 'Assays.SampleStatus.Broken' : 'InstrumentStatus.Broken';
      case 8: return isSample ? 'Assays.SampleStatus.WaittingCertificateApproval' : 'InstrumentStatus.WaittingCertificateApproval';
      case 10: return 'InstrumentStatus.WaittingBudgetApproval';
      default: return '';
    }
  }

  getStatusIcon(status: number): string {
    switch (status) {
      case 2: return 'business';
      case 3: return 'assignment';
      case 4: return 'attach_money';
      case 5: return 'slow_motion_video';
      case 6: return 'local_shipping';
      case 7: return 'phonelink_erase';
      case 8: return 'thumbs_up_down';
      case 10: return 'monetization_on';
      default: return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/instruments/shared/instrument.service.ts